import ApiService, { HTTPMethod } from "./api.core";
import { Transformer } from "../models/Transformer";
import { COI } from "../models/coi/coi.model";

class PolicyManagementCOIApi {

  async getPolicyCOIs(insuranceId) {
    let res = await ApiService.fetch(`certificates/all/${insuranceId}`)
    if(res.ok) {
      res.parsedData = res.data.certificates.map(coi => Transformer.initializeFromDataDeep(new COI(), coi))
    }
    return res
  }

  async getMeargedPolicyCOIs(insuranceId) {
    var res = await ApiService.fetch(`certificates/merged_coi/${insuranceId}`)
    return res
  }

  async getMainCOIUrl(insuranceId) {
    const res = await ApiService.fetch(`certificates/get_main_coi_url/${insuranceId}`, HTTPMethod.GET);
    return res
  }

  async getSpecificCOIUrl(insuranceId, certificateId) {
    const res = await ApiService.fetch(`certificates/get_specific_coi/${insuranceId}/${certificateId}`, HTTPMethod.GET);
    return res
  }
}

export default new PolicyManagementCOIApi()